const routes = require.context(
  // O caminho relativo da pasta
  "./modules",
  // Se deve ou não olhar subpastas
  true,
  // Expressão regular para localizar nomes
  /.route./
);

const reducers = require.context(
  // O caminho relativo da pasta
  "./modules",
  // Se deve ou não olhar subpastas
  true,
  // Expressão regular para localizar nomes
  /.reducer./
);

const sagas = require.context(
  // O caminho relativo da pasta
  "./modules",
  // Se deve ou não olhar subpastas
  true,
  // Expressão regular para localizar nomes
  /.saga./
);

const breadcrumbs = require.context(
  // O caminho relativo da pasta
  "./modules",
  // Se deve ou não olhar subpastas
  true,
  // Expressão regular para localizar nomes
  /.breadcrumb./
);

export { routes, reducers, sagas, breadcrumbs };
